import contentfulApi from './contentfulApi'

export default contentfulApi
